import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'


function RTISection4AdministrationEle6Pg() {
    return(
        <>
            
                <div className='container'>
                            <div className='ms-3'>
                                <h4>Publicity and Public Interface</h4>
                            
                                <table className="table table-striped">
                                    <tbody>
                                        <tr>
                                        <td >
                                        <strong>S. No.</strong>
                                        </td>
                                        <td >
                                        <strong>Item</strong>
                                        </td>
                                        <td >
                                        <strong>Details</strong>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        <strong>3.1</strong>
                                        </td>
                                        <td colspan="2">
                                        <strong>Particulars for any arrangement for consultation with or representation by the members of the public in relation to the formulation of policy or implementation there of [Section 4 (1) (b)(vii)] [F.No.1/6/2011-IR dt.15.04.2013]</strong>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.1.
                                        </td>
                                        <td>
                                        Relevant Acts, Rules, Forms and other documents which are normally
                                        accessed by citizens
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.2
                                        </td>
                                        <td>
                                        Arrangements for consultation with or representation by - (a) Members of
                                        the public in policy formulation / policy implementation, (b) Day &amp; time
                                        allotted for visitors, (c) Contact details of Information &amp; Facilitation Counter
                                        (IFC) to provide publications frequently sought by RTI applicants
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.3
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP)- Details of Special Purpose Vehicle
                                        (SPV), if any
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.4
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP)- Detailed project reports (DPRs)
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.5
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP)- Concession agreements.
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.6
                                        </td>
                                        <td>
                                        Public- private partnerships (PPP)- Operation and maintenance manuals
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.7
                                        </td>
                                        <td>
                                        Public- private partnerships (PPP) - Other documents generated as part of
                                        the implementation of the PPP
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.8
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP) - Information relating to fees, tolls, or
                                        the other kinds of revenues that may be collected under authorisation from
                                        the government
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.9
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP) -Information relating to outputs and
                                        outcomes
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.10
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP) - The process of the selection of the
                                        private sector party (concessionaire etc.)
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.1.11
                                        </td>
                                        <td>
                                        Public-private partnerships (PPP) - All payment made under the PPP
                                        project
                                        </td>
                                        <td>
                                        Not Applicable
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        <strong>3.2</strong>
                                        </td>
                                        <td colspan="2">
                                        <strong>Are the details of policies / decisions, which affect public, informed to them [Section 4(1) (c)]</strong>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.2.1
                                        </td>
                                        <td>
                                        Publish all relevant facts while formulating important policies or
                                        announcing decisions which affect public to make the process more
                                        interactive - Policy decisions / legislations taken in the previous one year
                                        </td>
                                        <td>
                                        Not Applicable<br />
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.2.2
                                        </td>
                                        <td>
                                        Publish all relevant facts while formulating important policies or
                                        announcing decisions which affect public to make the process more
                                        interactive - Outline the Public consultation process
                                        </td>
                                        <td>
                                        Not Applicable<br />
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.2.3
                                        </td>
                                        <td>
                                        Publish all relevant facts while formulating important policies or
                                        announcing decisions which affect public to make the process more
                                        interactive- Outline the arrangement for consultation before formulation of policy
                                        </td>
                                        <td>
                                        Not Applicable<br />
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        <strong>3.3</strong>
                                        </td>
                                        <td colspan="2">
                                        <strong>Dissemination of information widely and in such form and manner which is easily accessible to the public [Section 4(3)]</strong>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.3.1
                                        </td>
                                        <td>
                                        Use of the most effective means of communication - Internet (website)
                                        </td>
                                        <td>
                                        <a className="c-link" href="https://iittp.ac.in/">https://iittp.ac.in/</a>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        <strong>3.4</strong>
                                        </td>
                                        <td colspan="2">
                                        <strong>Form of accessibility of information manual / handbook [Section 4(1)(b)]</strong>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.4.1
                                        </td>
                                        <td>
                                        Information manual / handbook available in Electronic format
                                        </td>
                                        <td>
                                        <a className="c-link" href="https://iittp.ac.in/academics/ordinances" target="_blank;">Ordinances &amp; Regulations</a>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.4.2
                                        </td>
                                        <td>
                                        Information manual / handbook available in Printed format
                                        </td>
                                        <td>
                                        NIL
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        <strong>3.5</strong>
                                        </td>
                                        <td colspan="2">
                                        <strong>Whether information manual / handbook available free of cost or not [Section 4(1)(b)]</strong>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.5.1
                                        </td>
                                        <td>
                                        List of materials available Free of cost
                                        </td>
                                        <td>
                                        NIL
                                        </td>
                                        </tr>
                                        <tr>
                                        <td>
                                        3.5.2
                                        </td>
                                        <td>
                                        List of materials available At a reasonable cost of the medium
                                        </td>
                                        <td>
                                        NIL
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                                            
                            </div>
                    </div> 
            
        </>
    );
}

export default RTISection4AdministrationEle6Pg;